module.exports = __webpack_public_path__ + "media/images/it/icons/quit-7b9af72a797955abdb5f48efd2517792.svg";